/**
 * Performance Cards Renderer
 * Renderiza las tarjetas del Performance Detallado con scroll horizontal y filtros
 */

let currentFilter = 'all';
let currentStatusFilter = 'all';
let isRenderingInProgress = false;

// Toggle para mostrar/ocultar opciones en cards
function toggleCardActions(btn) {
    const footer = btn.closest('.perf-card-toggle').nextElementSibling;
    const isHidden = footer.style.display === 'none';
    
    if (isHidden) {
        footer.style.display = 'flex';
        footer.style.maxHeight = '100px';
        footer.style.padding = '12px 0';
        btn.textContent = '▲ Cerrar';
    } else {
        footer.style.maxHeight = '0';
        footer.style.padding = '0';
        footer.style.display = 'none';
        btn.textContent = '▼ Opciones';
    }
}

function renderPerformanceCardsNew() {
    // Evitar renders simultáneos
    if (isRenderingInProgress) return;
    isRenderingInProgress = true;
    
    try {
        const container = document.getElementById('performanceGrid');
        if (!container) return;

        if (!window.accounts || window.accounts.length === 0) {
            container.innerHTML = '<div class="text-center py-8 text-slate-400">No hay cuentas registradas</div>';
            const prevBtn = document.getElementById('scrollPrev');
            const nextBtn = document.getElementById('scrollNext');
            if (prevBtn) prevBtn.style.display = 'none';
            if (nextBtn) nextBtn.style.display = 'none';
            return;
        }

        container.innerHTML = '';
        
        // Filtrar cuentas según el filtro actual
        const filteredAccounts = getFilteredAccounts();

        if (filteredAccounts.length === 0) {
            const emptyMessage = document.createElement('div');
            emptyMessage.className = 'absolute inset-0 flex items-center justify-center';
            emptyMessage.innerHTML = `
                <div class="text-center">
                    <svg class="w-16 h-16 mx-auto mb-4 opacity-50 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                    </svg>
                    <p class="text-lg font-semibold mb-2 text-slate-300">No hay cuentas disponibles</p>
                    <p class="text-sm text-slate-400">No se encontraron cuentas con el filtro seleccionado</p>
                </div>
            `;
            
            const wrapper = document.createElement('div');
            wrapper.className = 'relative w-full h-96';
            wrapper.appendChild(emptyMessage);
            container.appendChild(wrapper);
            const prevBtn = document.getElementById('scrollPrev');
            const nextBtn = document.getElementById('scrollNext');
            if (prevBtn) prevBtn.style.display = 'none';
            if (nextBtn) nextBtn.style.display = 'none';
            return;
        }

        filteredAccounts.forEach((account, index) => {
        const metrics = account.metrics || {};
        const roi = parseFloat(metrics.roi) || 0;
        const winRate = parseFloat(metrics.winRate) || 0;
        const profitFactor = parseFloat(metrics.profitFactor) || 0;
        const totalTrades = metrics.totalTrades || 0;
        const totalProfit = parseFloat(metrics.totalProfit) || 0;
        const initialBalance = account.initial_balance || 10000;
        const balance = initialBalance + totalProfit; // Balance actual = inicial + profit total
        const drawdown = (() => {
            const base = Number(initialBalance) || 0;
            if (!base) return 0;
            const dd = (Number(totalProfit) || 0) / base * 100;
            return dd < 0 ? dd : 0;
        })();

        // Determinar color según tipo
        const typeColors = getTypeColors(account.type);
        const profitText = totalProfit >= 0 ? `+$${Math.abs(totalProfit).toFixed(2)}` : `-$${Math.abs(totalProfit).toFixed(2)}`;

        // Calcular objetivo usando valores personalizados o defaults
        let objective = account.roi_objective;
        if (!objective) {
            // Usar defaults si no hay objetivo personalizado
            objective = account.type.includes('challenge_f1') ? 10 :
                       account.type.includes('challenge_f2') ? 5 : null;
        }
        const progressPercent = objective ? (roi > 0 ? Math.min(100, (roi / objective) * 100) : 0) : 0;

        const card = document.createElement('div');
        card.className = `group bg-gradient-to-br from-slate-800/40 to-slate-900/60 border border-slate-700/50 rounded-2xl p-6 hover:border-${typeColors.hoverBorder}/50 hover:shadow-xl hover:shadow-${typeColors.hoverGlow}/10 transition-all duration-300 hover:-translate-y-1 draggable-card flex-shrink-0 w-80`;
        card.setAttribute('draggable', 'true');
        card.setAttribute('data-account-id', account.id);
        card.setAttribute('data-account-name', account.name);
        card.setAttribute('data-is-archived', account.is_archived ? 'true' : 'false');

        card.innerHTML = `
            <!-- Header -->
            <div class="flex items-center gap-3 mb-4">
                <div class="w-10 h-10 rounded-full bg-gradient-to-br ${typeColors.gradient} flex items-center justify-center text-sm font-bold text-white flex-shrink-0">
                    ${(index + 1).toString().padStart(2, '0')}
                </div>
                <div class="flex-1 min-w-0">
                    <h3 class="font-bold text-white truncate">${account.name}</h3>
                    <span class="text-xs px-2 py-0.5 rounded-full ${typeColors.badge} border ${typeColors.badgeBorder} inline-block">
                        ${getTypeDisplay(account.type)}
                    </span>
                </div>
            </div>

            <!-- Status & Priority Badges -->
            <div class="flex gap-2 mb-4 flex-wrap">
                <!-- Estado -->
                <div class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-slate-700/30 border border-slate-600/50">
                    ${account.status === 'active' ? `
                        <svg class="w-3.5 h-3.5 text-green-400" fill="currentColor" viewBox="0 0 24 24">
                            <circle cx="12" cy="12" r="10"/><path d="M9 12l2 2 4-4" stroke="black" stroke-width="2" fill="none"/>
                        </svg>
                        <span class="text-xs font-medium text-green-300">Activa</span>
                    ` : account.status === 'burned' ? `
                        <svg class="w-3.5 h-3.5 text-red-400" fill="currentColor" viewBox="0 0 24 24">
                            <circle cx="12" cy="12" r="10"/><path d="M8 16h8M10 8h4" stroke="black" stroke-width="2"/>
                        </svg>
                        <span class="text-xs font-medium text-red-300">Quemada</span>
                    ` : account.status === 'superado' ? `
                        <svg class="w-3.5 h-3.5 text-yellow-400" fill="currentColor" viewBox="0 0 24 24">
                            <circle cx="12" cy="12" r="10"/><path d="M8 12h8M12 8v8" stroke="black" stroke-width="2"/>
                        </svg>
                        <span class="text-xs font-medium text-yellow-300">Superado</span>
                    ` : `
                        <svg class="w-3.5 h-3.5 text-slate-400" fill="currentColor" viewBox="0 0 24 24">
                            <circle cx="12" cy="12" r="10"/>
                        </svg>
                        <span class="text-xs font-medium text-slate-300">Inactiva</span>
                    `}
                </div>
                
                <!-- Prioridad -->
                <div class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg cursor-help ${
                    account.priority === 'high' ? 'bg-red-500/15 border border-red-500/30' :
                    account.priority === 'medium' ? 'bg-amber-500/15 border border-amber-500/30' :
                    'bg-blue-500/15 border border-blue-500/30'
                }" title="${account.priority === 'high' ? 'Prioridad Alta: Cuenta crítica, requiere atención constante' : account.priority === 'medium' ? 'Prioridad Media: Cuenta importante, monitoreo regular' : 'Prioridad Baja: Cuenta secundaria, menor urgencia'}">
                    <div class="flex gap-0.5">
                        ${account.priority === 'high' ? `
                            <span class="text-red-400">●</span>
                            <span class="text-red-400">●</span>
                            <span class="text-red-400">●</span>
                        ` : account.priority === 'medium' ? `
                            <span class="text-amber-400">●</span>
                            <span class="text-amber-400">●</span>
                            <span class="text-slate-600">●</span>
                        ` : `
                            <span class="text-blue-400">●</span>
                            <span class="text-slate-600">●</span>
                            <span class="text-slate-600">●</span>
                        `}
                    </div>
                </div>
            </div>

            <!-- Balance -->
            <div class="mb-4">
                <div class="text-3xl font-bold bg-gradient-to-r ${totalProfit >= 0 ? 'from-green-400 to-emerald-500' : 'from-red-400 to-rose-500'} bg-clip-text text-transparent mb-1">
                    ${formatCurrency(balance)}
                </div>
                <div class="flex items-center gap-2 text-sm">
                    <span class="text-${totalProfit >= 0 ? 'green' : 'red'}-400">${totalProfit >= 0 ? '+' : ''}${formatCurrency(totalProfit)}</span>
                    <span class="text-slate-500">•</span>
                    <span class="text-slate-400">${roi > 0 ? '+' : ''}${roi.toFixed(1)}%</span>
                </div>
            </div>

            <!-- Progress Bar -->
            <div class="mb-4">
                <div class="flex justify-between text-xs text-slate-400 mb-2">
                    <span>Objetivo: ${objective ? objective.toFixed(1) + '%' : 'Sin límite'}</span>
                    <span>${Math.min(100, progressPercent).toFixed(0)}%</span>
                </div>
                <div class="h-2 bg-slate-700/50 rounded-full overflow-hidden">
                    <div class="h-full bg-gradient-to-r ${typeColors.progress} rounded-full" style="width: ${Math.min(100, progressPercent)}%"></div>
                </div>
            </div>

            <!-- Metrics Grid -->
            <div class="grid grid-cols-2 gap-3 mb-4">
                <div class="bg-slate-900/50 rounded-lg p-3 border border-slate-700/50">
                    <div class="text-xs text-slate-400 mb-1">Win Rate</div>
                    <div class="text-lg font-bold text-cyan-400">${winRate.toFixed(1)}%</div>
                </div>
                <div class="bg-slate-900/50 rounded-lg p-3 border border-slate-700/50">
                    <div class="text-xs text-slate-400 mb-1">Trades</div>
                    <div class="text-lg font-bold text-white">${totalTrades}</div>
                </div>
                <div class="bg-slate-900/50 rounded-lg p-3 border border-slate-700/50">
                    <div class="text-xs text-slate-400 mb-1">Profit Factor</div>
                    <div class="text-lg font-bold text-purple-400">${profitFactor.toFixed(2)}</div>
                </div>
                <div class="bg-slate-900/50 rounded-lg p-3 border border-slate-700/50">
                    <div class="text-xs text-slate-400 mb-1">Drawdown</div>
                    <div class="text-lg font-bold text-${drawdown < 0 ? 'red' : 'yellow'}-400">${drawdown.toFixed(1)}%</div>
                </div>
            </div>

            <!-- Toggle Options Button -->
            <div class="perf-card-toggle" style="padding-top: 8px; border-top: 1px solid rgba(255, 255, 255, 0.08);">
                <button class="perf-toggle-btn" onclick="toggleCardActions(this)" style="background: none; border: none; color: #90a4ae; cursor: pointer; font-size: 14px; padding: 8px 12px; width: 100%; text-align: center; transition: all 0.2s; font-weight: 600;">
                    ▼ Opciones
                </button>
            </div>

            <!-- Actions Footer -->
            <div class="perf-card-footer" style="display: none; max-height: 0; overflow: hidden; transition: max-height 0.3s ease, padding 0.3s ease;">
                <div style="display: flex; gap: 6px; width: 100%;">
                    <button class="perf-card-btn" onclick="toggleFavoriteAccount(event, '${account.id}')" style="background: none; border: 1px solid #90a4ae; color: ${Number(account.is_primary) === 1 ? '#ffd700' : '#90a4ae'}; cursor: pointer; font-size: 16px; padding: 6px 8px; border-radius: 6px; transition: all 0.2s; flex: 1; display: flex; align-items: center; justify-content: center;" title="Cuenta Principal">${Number(account.is_primary) === 1 ? '★' : '☆'}</button>
                    <button class="perf-card-btn" onclick="goToAccountJournal('${account.id}')" style="background: none; border: 1px solid #90a4ae; color: #ff9a3c; cursor: pointer; font-size: 16px; padding: 6px 8px; border-radius: 6px; transition: all 0.2s; flex: 1; display: flex; align-items: center; justify-content: center;" title="Ver Journal"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg></button>
                    <button class="perf-card-btn" onclick="showSettingsModal('${account.id}')" style="background: none; border: 1px solid #90a4ae; color: #90a4ae; cursor: pointer; font-size: 16px; padding: 6px 8px; border-radius: 6px; transition: all 0.2s; flex: 1; display: flex; align-items: center; justify-content: center;" title="Ajustes"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/></svg></button>
                    <button class="perf-card-btn" onclick="showDeleteConfirmation('${account.id}', '${account.name}')" style="background: none; border: 1px solid #90a4ae; color: #ff6b6b; cursor: pointer; font-size: 16px; padding: 6px 8px; border-radius: 6px; transition: all 0.2s; flex: 1; display: flex; align-items: center; justify-content: center;" title="Eliminar"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg></button>
                </div>
            </div>
        `;

        // Agregar event listeners para drag
        card.addEventListener('dragstart', handleDragStart);
        card.addEventListener('dragend', handleDragEnd);

        container.appendChild(card);
    });

    // Setup archive zone
    setupArchiveZone();
    
    // Setup scroll buttons
    setupScrollButtons();
    
    // Re-setup filter buttons to ensure event listeners are attached
    setupFilterButtons();
    setupStatusFilterSelect();
    
    } finally {
        isRenderingInProgress = false;
    }
}

function getTypeDisplay(accountType) {
    const typeMap = {
        'challenge_f1': 'Challenge F1',
        'challenge_f2': 'Challenge F2',
        'fondeada': 'Fondeada',
        'funded': 'Fondeada',
        'personal': 'Personal'
    };
    const normalized = normalizeAccountType(accountType);
    return typeMap[normalized] || accountType;
}

function getTypeColors(accountType) {
    const typeMap = {
        'challenge_f1': {
            gradient: 'from-cyan-500 to-blue-500',
            hoverBorder: 'cyan',
            hoverGlow: 'cyan',
            badge: 'bg-cyan-500/15 text-cyan-400',
            badgeBorder: 'border-cyan-500/30',
            progress: 'from-cyan-500 to-blue-500',
            buttonBg: 'bg-cyan-600/20',
            buttonBorder: 'border-cyan-500/30',
            buttonText: 'text-cyan-300',
            buttonHover: 'bg-cyan-600/30'
        },
        'challenge_f2': {
            gradient: 'from-yellow-500 to-orange-500',
            hoverBorder: 'yellow',
            hoverGlow: 'yellow',
            badge: 'bg-yellow-500/15 text-yellow-400',
            badgeBorder: 'border-yellow-500/30',
            progress: 'from-yellow-500 to-orange-500',
            buttonBg: 'bg-yellow-600/20',
            buttonBorder: 'border-yellow-500/30',
            buttonText: 'text-yellow-300',
            buttonHover: 'bg-yellow-600/30'
        },
        'fondeada': {
            gradient: 'from-green-500 to-emerald-500',
            hoverBorder: 'green',
            hoverGlow: 'green',
            badge: 'bg-green-500/15 text-green-400',
            badgeBorder: 'border-green-500/30',
            progress: 'from-green-500 to-emerald-500',
            buttonBg: 'bg-green-600/20',
            buttonBorder: 'border-green-500/30',
            buttonText: 'text-green-300',
            buttonHover: 'bg-green-600/30'
        },
        'funded': {
            gradient: 'from-green-500 to-emerald-500',
            hoverBorder: 'green',
            hoverGlow: 'green',
            badge: 'bg-green-500/15 text-green-400',
            badgeBorder: 'border-green-500/30',
            progress: 'from-green-500 to-emerald-500',
            buttonBg: 'bg-green-600/20',
            buttonBorder: 'border-green-500/30',
            buttonText: 'text-green-300',
            buttonHover: 'bg-green-600/30'
        },
        'personal': {
            gradient: 'from-purple-500 to-pink-500',
            hoverBorder: 'purple',
            hoverGlow: 'purple',
            badge: 'bg-purple-500/15 text-purple-400',
            badgeBorder: 'border-purple-500/30',
            progress: 'from-purple-500 to-pink-500',
            buttonBg: 'bg-purple-600/20',
            buttonBorder: 'border-purple-500/30',
            buttonText: 'text-purple-300',
            buttonHover: 'bg-purple-600/30'
        }
    };
    const normalized = normalizeAccountType(accountType);
    return typeMap[normalized] || typeMap['personal'];
}

function getObjectiveByType(accountType, roi) {
    const typeMap = {
        'challenge_f1': 10,
        'challenge_f2': 5,
        'fondeada': null,
        'funded': null,
        'personal': null
    };
    const normalized = normalizeAccountType(accountType);
    const objective = typeMap[normalized];
    return objective !== null ? objective : Math.max(0, roi + 50);
}

function formatCurrency(value) {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(value || 0);
}

function openDetailModal(accountId) {
    const account = window.accounts.find(a => a.id === accountId);
    if (!account) return;
    
    // TODO: Abrir modal con detalles de la cuenta
    if (window.showAlert) {
        window.showAlert('Próximamente', `Modal de detalles para ${account.name} (próximamente)`, 'info');
    }
}

/**
 * Alterna el estado de archivo de una cuenta (desde el botón)
 */
function toggleArchiveAccount(accountId, accountName, isCurrentlyArchived) {
    const account = window.accounts.find(a => a.id === accountId);
    if (!account) return;
    
    // Cambiar estado localmente
    const newArchivedState = !isCurrentlyArchived;
    account.is_archived = newArchivedState;
    
    // Re-renderizar inmediatamente
    renderPerformanceCardsNew();
    
    // Enviar cambio al servidor de forma asincrónica (el servidor mostrará la notificación)
    if (window.toggleArchiveAccountAsync) {
        window.toggleArchiveAccountAsync(accountId, accountName, newArchivedState);
    }
}

// Drag and Drop
let draggedCard = null;

function handleDragStart(e) {
    draggedCard = this;
    this.style.opacity = '0.5';
    e.dataTransfer.effectAllowed = 'move';
}

function handleDragEnd(e) {
    this.style.opacity = '1';
    draggedCard = null;
}

function setupArchiveZone() {
    const archiveZone = document.getElementById('archiveZone');
    const archiveText = document.getElementById('archiveText');
    const container = document.getElementById('performanceGrid');
    
    if (!archiveZone || !container) return;
    
    // Clonar archiveZone para remover TODOS los listeners anteriores
    const newArchiveZone = archiveZone.cloneNode(true);
    archiveZone.parentNode.replaceChild(newArchiveZone, archiveZone);
    
    const freshArchiveZone = document.getElementById('archiveZone');
    const freshArchiveText = document.getElementById('archiveText');
    
    // Actualizar el texto y clase según el filtro
    if (currentFilter === 'archived') {
        freshArchiveText.textContent = 'Suelta aquí para desarchivados';
        freshArchiveZone.classList.add('unarchive-mode');
        freshArchiveZone.classList.remove('archive-mode');
    } else {
        freshArchiveText.textContent = 'Suelta aquí para archivar';
        freshArchiveZone.classList.remove('unarchive-mode');
        freshArchiveZone.classList.add('archive-mode');
    }
    
    // Agregar listeners al contenedor
    container.addEventListener('dragover', (e) => {
        e.preventDefault();
        freshArchiveZone.style.display = 'flex';
    });

    freshArchiveZone.addEventListener('dragover', (e) => {
        e.preventDefault();
        freshArchiveZone.classList.add('active');
    });

    freshArchiveZone.addEventListener('dragleave', (e) => {
        if (e.target === freshArchiveZone) {
            freshArchiveZone.classList.remove('active');
        }
    });

    freshArchiveZone.addEventListener('drop', (e) => {
        e.preventDefault();
        e.stopPropagation();
        freshArchiveZone.classList.remove('active');
        freshArchiveZone.style.display = 'none';

        if (draggedCard) {
            const accountId = draggedCard.getAttribute('data-account-id');
            const accountName = draggedCard.getAttribute('data-account-name');
            const isCurrentlyArchived = draggedCard.getAttribute('data-is-archived') === 'true';
            
            // Toggle el estado de archivo
            const account = window.accounts.find(a => a.id === accountId);
            if (account) {
                account.is_archived = !isCurrentlyArchived;
            }
            
            // Limpiar variable draggedCard para evitar duplicate drops
            draggedCard = null;
            
            // Enviar al servidor de forma asincrónica (el servidor mostrará la notificación)
            if (window.toggleArchiveAccountAsync) {
                window.toggleArchiveAccountAsync(accountId, accountName, !isCurrentlyArchived);
            }
            
            // Re-renderizar SIN RECARGAR (después de enviar al servidor)
            setTimeout(() => {
                renderPerformanceCardsNew();
            }, 100);
        }
    });

    document.addEventListener('dragend', (e) => {
        freshArchiveZone.style.display = 'none';
        freshArchiveZone.classList.remove('active');
    });
}

/**
 * Normaliza el tipo de cuenta para comparación
 */
function normalizeAccountType(accountType) {
    if (!accountType) return '';
    const normalized = accountType.toLowerCase().replace(/ /g, '_');
    
    // Mapear variantes
    if (normalized.includes('challenge_f1')) return 'challenge_f1';
    if (normalized.includes('challenge_f2')) return 'challenge_f2';
    if (normalized.includes('fondeada') || normalized === 'funded') return 'funded';
    if (normalized.includes('personal')) return 'personal';
    
    return normalized;
}

/**
 * Filtra las cuentas según el filtro actual
 */
function getFilteredAccounts() {
    if (!window.accounts) return [];

    return window.accounts.filter(account => {
        const normalizedType = normalizeAccountType(account.type);
        
        // Filtro por tipo
        let typeMatch = false;
        if (currentFilter === 'all') {
            typeMatch = !account.is_archived;
        } else if (currentFilter === 'archived') {
            typeMatch = account.is_archived;
        } else {
            typeMatch = normalizedType === currentFilter && !account.is_archived;
        }
        
        // Si no pasa el filtro de tipo, return false
        if (!typeMatch) return false;
        
        // Filtro por estado
        if (currentStatusFilter === 'all') {
            return true; // Ya pasó el filtro de tipo
        }
        
        const status = account.status || 'active';
        
        // Mostrar solo el estado seleccionado
        return status === currentStatusFilter;
    });
}

/**
 * Setup event listeners para botones de filtro
 */
function setupFilterButtons() {
    const filterButtons = document.querySelectorAll('.filter-btn');
    
    // Clonar para remover todos los listeners anteriores
    filterButtons.forEach(btn => {
        const newBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(newBtn, btn);
    });
    
    // Re-query después de reemplazar
    const freshButtons = document.querySelectorAll('.filter-btn');
    
    // Función para actualizar estilos basado en estado activo
    function updateButtonStyles(buttons, activeFilter) {
        buttons.forEach(btn => {
            const isActive = btn.getAttribute('data-filter') === activeFilter;
            const baseClasses = 'filter-btn px-4 py-2 rounded-lg text-sm font-semibold transition-all';
            
            // Preservar clases especiales para cada botón
            let specialClasses = '';
            if (btn.getAttribute('data-filter') === 'archived') {
                specialClasses = ' flex items-center gap-2 whitespace-nowrap';
            }
            
            if (isActive) {
                btn.className = baseClasses + specialClasses + ' active bg-gradient-to-r from-cyan-600/40 to-blue-600/40 border border-cyan-500/50 text-cyan-300';
            } else {
                btn.className = baseClasses + specialClasses + ' bg-slate-800/50 border border-slate-700 text-slate-400 hover:text-cyan-300 hover:border-cyan-500/30';
            }
        });
    }
    
    freshButtons.forEach(btn => {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            const filter = this.getAttribute('data-filter');
            currentFilter = filter;
            
            // Actualizar estilos de todos los botones
            updateButtonStyles(freshButtons, filter);
            
            // Re-renderizar las tarjetas
            renderPerformanceCardsNew();
        });
    });
    
    // Establecer estilos iniciales
    updateButtonStyles(freshButtons, currentFilter);
}

function setupStatusFilterSelect() {
    const statusSelect = document.getElementById('performanceStatusSelect');
    if (!statusSelect) return;
    
    statusSelect.addEventListener('change', function(e) {
        currentStatusFilter = this.value;
        renderPerformanceCardsNew();
    });
}

/**
 * Setup botones de scroll horizontal
 */
function setupScrollButtons() {
    const scrollContainer = document.getElementById('performanceScroll');
    const scrollPrevBtn = document.getElementById('scrollPrev');
    const scrollNextBtn = document.getElementById('scrollNext');
    
    if (!scrollContainer || !scrollPrevBtn || !scrollNextBtn) return;
    
    // Eliminar listeners anteriores para evitar duplicados
    const newPrevBtn = scrollPrevBtn.cloneNode(true);
    const newNextBtn = scrollNextBtn.cloneNode(true);
    scrollPrevBtn.parentNode.replaceChild(newPrevBtn, scrollPrevBtn);
    scrollNextBtn.parentNode.replaceChild(newNextBtn, scrollNextBtn);
    
    const prevBtn = document.getElementById('scrollPrev');
    const nextBtn = document.getElementById('scrollNext');
    
    const scrollAmount = 400;
    
    function updateButtonStates() {
        const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
        if (!isDesktop) {
            prevBtn.style.display = 'none';
            nextBtn.style.display = 'none';
            return;
        }

        const scrollLeft = scrollContainer.scrollLeft;
        const scrollWidth = scrollContainer.scrollWidth;
        const clientWidth = scrollContainer.clientWidth;
        const cards = scrollContainer.querySelectorAll('.draggable-card');
        
        if (cards.length < 5) {
            prevBtn.style.display = 'none';
            nextBtn.style.display = 'none';
            return;
        }
        
        prevBtn.style.display = scrollLeft <= 0 ? 'none' : 'flex';
        nextBtn.style.display = (scrollLeft + clientWidth >= scrollWidth - 10) ? 'none' : 'flex';
    }
    
    prevBtn.addEventListener('click', () => {
        scrollContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        setTimeout(updateButtonStates, 300);
    });
    
    nextBtn.addEventListener('click', () => {
        scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        setTimeout(updateButtonStates, 300);
    });
    
    updateButtonStates();
    scrollContainer.addEventListener('scroll', updateButtonStates);
}

/**
 * Setup fades para botones de filtro con scroll
 */
function setupFilterButtonsFade() {
    const filterContainer = document.getElementById('filterButtonsContainer');
    const filterFadeLeft = document.getElementById('filterFadeLeft');
    const filterFadeRight = document.getElementById('filterFadeRight');
    
    if (!filterContainer || !filterFadeLeft || !filterFadeRight) return;
    
    function updateFilterFades() {
        const scrollLeft = filterContainer.scrollLeft;
        const scrollWidth = filterContainer.scrollWidth;
        const clientWidth = filterContainer.clientWidth;
        const hasOverflow = scrollWidth > clientWidth;
        
        if (!hasOverflow) {
            filterFadeLeft.style.opacity = '0';
            filterFadeRight.style.opacity = '0';
            return;
        }
        
        // Mostrar fade izquierdo si scrolleó
        filterFadeLeft.style.opacity = scrollLeft > 5 ? '1' : '0';
        
        // Mostrar fade derecho si hay más contenido
        filterFadeRight.style.opacity = (scrollLeft + clientWidth < scrollWidth - 5) ? '1' : '0';
    }
    
    // Actualizar después de un delay
    setTimeout(updateFilterFades, 150);
    
    filterContainer.addEventListener('scroll', updateFilterFades);
    window.addEventListener('resize', updateFilterFades);
}

// Inicializar cuando se carguen las cuentas
document.addEventListener('DOMContentLoaded', () => {
    const checkAccounts = setInterval(() => {
        if (window.accounts && Array.isArray(window.accounts)) {
            clearInterval(checkAccounts);
            renderPerformanceCardsNew();
            setupFilterButtons();
            setupStatusFilterSelect();
            setupFilterButtonsFade();
        }
    }, 500);
});

// Exponer función globalmente para que accounts.js pueda llamarla
window.renderPerformanceCardsNew = renderPerformanceCardsNew;
